import { appModules } from '../services/licence.service';
import { MenuItem } from './menu.item.model';

export const items: MenuItem[] = [
  {
    icon: 'home',
    name: 'nav.home',
    route: '/home',
  },
  {
    icon: 'diamond',
    name: 'nav.kanban',
    route: '/week-user',
    module: appModules.essentials,
  },
  {
    icon: 'newspaper',
    name: 'nav.news',
    route: '/worker/messages',
    module: appModules.essentials,
  },
  {
    icon: 'calendar-number-outline',
    name: 'nav.workingCalendar',
    route: '/user-week-calendar',
    module: appModules.users,
  },
];

export const workerMenu = {
  items,
};
